import { createSelector } from 'reselect';

import { hasControlOverManagementStakeholders } from '@/flow/configs/selectors';

export const getDefaultState = createSelector(
  hasControlOverManagementStakeholders,
  hasControlOverManagementStakeholders => ({
    toggleValue: hasControlOverManagementStakeholders ? false : undefined,
  }),
);
